module.exports = __webpack_public_path__ + "static/media/app-analysis.e858eacb.jpg";